'use client'

import IconStar from '@icon/agent/star.svg'
import IconStarFill from '@icon/agent/star-fill.svg'
import { useCallback, useMemo, useRef, useState } from 'react'
import { isFunction, map, times } from 'lodash-es'
import { mumFormat } from '@utils'
import classNames from 'classnames'
import { useBoolean } from 'react-use'

export default function ReviewStar({
  count,
  value,
  size,
  fill,
  className,
  onChange
}) {

  const [score, setScore] = useState(value)
  const [mousein, toggleMousein] = useBoolean(false)
  const viewScore = mousein && onChange ? score : value

  const starList = useMemo(() => {
    const eachCount = count || Math.ceil(viewScore)
    return times(eachCount, idx => {
      const n = idx + 1
      return mumFormat(Math.max(viewScore > n ? 100 : (viewScore - idx) * 100, 0), '0.[00]')
    })
  }, [viewScore, count])

  const mousemoveHandle = useCallback(idx => {
    return score => {
      setScore(idx + score)
    }
  }, [setScore])
  const clickHandle = useCallback(() => {
    isFunction(onChange) && onChange(score)
  }, [onChange, score])

  return (
    <div className={className}>
      <div className='inline-flex space-x-16' onMouseEnter={() => toggleMousein(true)} onMouseLeave={() => toggleMousein(false)}>
        {
          map(starList, (item, idx) => <Star value={item} size={size} fill={fill} key={idx} className={onChange && 'cursor-pointer'} onMouseMove={mousemoveHandle(idx)} onClick={clickHandle}></Star>)
        }
      </div>
    </div>
  )
}

export function Star({
  value,
  size = 14,
  fill = 'var(--color-theme)',
  className,
  onMouseMove,
  onClick,
}) {

  const width = useMemo(() => {
    return `${value < 1 ? value * 100 : value}%`
  }, [value])

  const wrapRef = useRef()
  const mousemoveHandle = useCallback(event => {
    const offset = event.pageX - wrapRef.current.offsetLeft
    const isLeft = size / 2 > offset
    const isLeftBoundary = size / 3 > offset
    isFunction(onMouseMove) && onMouseMove(isLeftBoundary ? 0 : isLeft ? 0.5 : 1)
  }, [wrapRef, size, onMouseMove])
  const clickHandle = useCallback(() => {
    isFunction(onClick) && onClick()
  }, [onClick])

  return (
    <div className={classNames('relative', className)} ref={wrapRef} onMouseMove={mousemoveHandle} onClick={clickHandle}>
      <IconStar width={size} height={size} fill={fill} className='block'></IconStar>
      <div className='absolute left-0 top-0 overflow-hidden' style={{ width }}>
        <IconStarFill width={size} height={size} fill={fill} className='block'></IconStarFill>
      </div>
    </div>
  )
}